import Lottie from "./Lottie";
import data from "./FilterScoop.json";

export default Lottie(data);
